import { useState } from "react";
import { HTTPError } from "@gocardless/api/utils/api";
import { useEmailVerificationCreate } from "@gocardless/api/dashboard/email-verification";

import { SignupFormData } from "./consts";

import { ShorthandLocale, useI18n } from "src/technical-integrations/i18n";

interface UseEmailVerificationProps {
  onSuccess: () => void;
  onError: (error: HTTPError) => void;
}

interface UseEmailVerification {
  createEmailVerification: (formData: SignupFormData) => void;
  isSubmitting: boolean;
}

export const useEmailVerification = ({
  onSuccess,
  onError,
}: UseEmailVerificationProps): UseEmailVerification => {
  const [userLocale] = useI18n();
  const language = ShorthandLocale[userLocale];

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const [submitEmailVerification] = useEmailVerificationCreate({
    onSuccess: async () => {
      setIsSubmitting(false);
      onSuccess();
    },
    onError: async (error) => {
      setIsSubmitting(false);
      onError(error);
    },
  });

  const createEmailVerification = (formData: SignupFormData) => {
    setIsSubmitting(true);
    submitEmailVerification({
      email: formData.email,
      language: language,
      password: formData.password,
      geo: formData.geo,
      creditor_type: formData.creditor_type,
      organisation_name: formData.business_name,
    });
  };

  return {
    createEmailVerification,
    isSubmitting,
  };
};
